<template>
    <div class="portlet light">

            <div class="ss-titre">
                <span class="font-red-sunglo uppercase bold">{{ this.$slots.default[0].text }}</span>
            </div>

        <div class="portlet-body">
    <table class="table">
        <thead>
            <tr>
                <th>Type</th>
                <th>Nom</th>
                <th>Sommet</th>
                <th>Difficulté</th>
                <th>Durée</th>
                <th>Pers Max</th>
                <th v-if="paraglide">Décollage</th>
                <th v-if="paraglide">Rejoindre Décollage</th>
                <th v-if="paraglide">Dénivelé</th>
                <th v-if="paraglide">Lieu décollage / Altitude</th>
                <th>Prix</th>
                <th style="width: 1em;"></th>
                <th style="width: 1em;"></th>
            </tr>
        </thead>
        <tbody>
            <tr v-for="(tariff, index) in tariffs" >
                <th class="firstToUpper" >{{tariff.type}}</th>
                <th class="firstToUpper" >{{tariff.name}}</th>
                <th>{{tariff.mountaintop}}</th>
                <th>{{tariff.difficulty}}</th>
                <th>{{tariff.duration}}</th>
                <th>{{tariff.max_persons}}</th>
                <th v-if="paraglide">{{tariff.takeoff}}</th>
                <th v-if="paraglide">{{tariff.landing}}</th>
                <th v-if="paraglide">{{tariff.vertical_drop}}</th>
                <th v-if="paraglide">{{tariff.takeoff_appointment}}</th>
                <th>{{tariff.price}}</th>
                <th><button class="btn btn-primary" @click.prevent="editTariff(tariff, paraglide, index)"><i class="fas fa-pencil-alt"></i></button></th>
                <th><button class="btn btn-danger" @click.prevent="deleteTariff(tariff, paraglide, index)"><i class="fa fa-trash"></i></button></th>
            </tr>
        </tbody>
    </table>
    </div>
</div>
</template>

<script>
export default {

  name: 'tariffList',
  props: ['tariffs', 'paraglide'],
  data () {
    return {

    }
  },
  methods:{
    editTariff (tariff, paraglide, index) {
        this.$emit('editTariff', tariff, paraglide, index)
    },
    deleteTariff (tariff, paraglide, index) {
        this.$emit('deleteTariff', tariff, paraglide, index)
    }
  }
}
</script>

<style lang="css" scoped>
    .firstToUpper{
        text-transform: capitalize;
    }
</style>
